// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ChannelEditStep_wrapper__3pJ8m","field":"ChannelEditStep_field__1t2R1","text":"ChannelEditStep_text__3_ilG"};